(() => {
  if (window.__ssoButtonHandlerInit) return;
  window.__ssoButtonHandlerInit = true;

  const buildAuthUrl = (button) => {
    const authUrl = button.dataset.authUrl;
    const clientId = button.dataset.clientId;
    const idp = button.dataset.idp;
    const responseType = button.dataset.responseType;
    const scopes = button.dataset.scopes;
    const state = button.dataset.state;
    const redirectUri = button.dataset.redirectUri;

    if (!authUrl || !clientId || !responseType || !scopes || !redirectUri) {
      console.log('[SSO] missing SSO config');
      return '';
    }

    const params = new URLSearchParams();
    params.set('client_id', clientId);
    if (idp) params.set('idp', idp);
    params.set('redirect_uri', redirectUri);
    params.set('response_type', responseType);
    params.set('scope', scopes.replace(/,/g, ' '));
    if (state) params.set('state', state);

    return `${authUrl}?${params.toString()}`;
  };

  const bindButtons = () => {
    const buttons = document.querySelectorAll('[data-sso-button="true"]');
    buttons.forEach((button) => {
      if (button.dataset.ssoBound === 'true') return;
      button.dataset.ssoBound = 'true';

      button.addEventListener('click', () => {
        const url = buildAuthUrl(button);
        if (!url) return;
        window.location.href = url;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindButtons);
  } else {
    bindButtons();
  }

  const observer = new MutationObserver(bindButtons);
  observer.observe(document.body, { childList: true, subtree: true });
})();
